function DownloadLink({ fill = '#000', ...props }) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 100 100"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M87.5 9.375h-75a6.248 6.248 0 00-6.25 6.25v56.25a6.251 6.251 0 006.25 6.25h6.25V87.5a3.122 3.122 0 001.781 2.813c.414.21.88.32 1.344.312a3.128 3.128 0 001.938-.688l14.78-11.811H87.5a6.251 6.251 0 006.25-6.25v-56.25a6.251 6.251 0 00-6.25-6.25l.001-.001zM64.719 45.969l-12.5 12.5a3.115 3.115 0 01-1.031.656 2.925 2.925 0 01-2.375 0 3.114 3.114 0 01-1.031-.656l-12.5-12.5a3.136 3.136 0 010-4.438 3.136 3.136 0 014.437 0l7.156 7.188V31.25a3.124 3.124 0 116.25 0v17.469l7.157-7.188a3.136 3.136 0 014.437 0 3.136 3.136 0 010 4.438z" />
    </svg>
  )
}

export default DownloadLink
